export const MAX_FILE_SIZE = 21 * 1024 * 1024; // 21MB

export const ALLOWED_FILE_TYPES = [
    'image/jpeg', 'image/png', 'image/gif', 'image/webp',
    'video/mp4', 'video/webm', 'video/ogg',
    'application/pdf', 'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
];

export const ORGANIZATION_TYPES = {
    AHA_LICENSE: [
        { displayLabel: 'AHA Training Center', value: 'AHA Training Center' },
        { displayLabel: 'AHA Training Site', value: 'AHA Training Site' },
    ],
    GENERAL: [
        { displayLabel: 'Educational Provider', value: 'Educational Provider' },
        { displayLabel: 'Healthcare Provider', value: 'Healthcare Provider' },
        { displayLabel: 'Emergency Medical Service', value: 'Emergency Medical Service' },
        { displayLabel: 'Government / Military', value: 'Government / Military' },
        { displayLabel: 'Other', value: 'Other' }
    ]
};

export const ROLE_OPTIONS = [
    { displayLabel: 'Educator', value: 'Educator' },
    { displayLabel: 'Purchaser', value: 'Purchaser' },
    { displayLabel: 'Administrator', value: 'Administrator' },
    { displayLabel: 'Technician', value: 'Technician' },
    { displayLabel: 'Manager', value: 'Manager' }
];

export const PRODUCT_OPTIONS = [
    { displayLabel: 'E-Book', value: 'E-Book' },
    { displayLabel: 'Course-URL', value: 'Course-URL' },
];
